/// <reference path="../groupthink-js.d.ts" />

import { apiRequest, fetcher } from '../lib';
import useSWR from 'swr';

export const useMessage = (agendaId?: string, threadId?: string, id?: string) => {
  const {
    data: message,
    error,
    isLoading,
    isValidating,
  } = useSWR(
    () =>
      Boolean(agendaId) && Boolean(threadId) && Boolean(id)
        ? `/v1/agendas/${agendaId}/threads/${threadId}/messages/${id}`
        : false,
    fetcher
  );

  return {
    thread: message?.data,
    isLoading,
    isValidating,
    isError: error,
  };
};

export const useMessages = (
  agendaId?: string,
  threadId?: string,
  options?: {
    useRealtimeResource?: (eventName, channel, mutate) => void;
  }
) => {
  const { useRealtimeResource } = options || {};
  const {
    data: message,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR<Groupthink.SuccessfulResponseContent<'message.index'>>(
    () =>
      Boolean(agendaId) && Boolean(threadId)
        ? `/v1/agendas/${agendaId}/threads/${threadId}/messages`
        : null,
    fetcher,
    { keepPreviousData: true }
  );

  useRealtimeResource?.(
    '.MessagesCreated',
    !agendaId && !threadId ? null : `App.Models.Messages.${agendaId}`,
    mutate
  );

  const sendMessage = <RouteName = 'message.send'>(
    content: string,
    {
      setErrors,
      setIsSending,
      onSuccess,
    }: Omit<Groupthink.BaseOperationOptions<RouteName>, 'payload'> & {
      setIsSending?: (isSending: boolean) => void;
    }
  ) =>
    apiRequest<RouteName>(`/v1/agendas/${agendaId}/threads/${threadId}/messages`, mutate, 'POST', {
      setErrors,
      setLoading: setIsSending,
      payload: { content },
      onSuccess,
    });

  return {
    messages: message?.data,
    isLoading,
    isValidating,
    isError: error,
    sendMessage,
    mutate,
  };
};
